import type { Inspection } from '@lib/spproject/types';
import { selectCurrentPalette } from '@store/reducers/accessibilitySlice';
import { AlertTriangle, Check, CircleIcon, X } from 'lucide-react';
import { type JSX } from 'react';
import { useSelector } from 'react-redux';

interface Props {
  status: Inspection.NoticeType;
  size?: number;
}

const PoiStatusIcon = ({ status = 'NotChecked', size = 16 }: Props) => {
  const palette = useSelector(selectCurrentPalette);
  const iconMap: Record<Inspection.NoticeType, JSX.Element> = {
    Ok: <Check color={palette.success} size={size} />,
    Warning: <AlertTriangle color={palette.warning} size={size} />,
    Error: <X size={size} color={palette.error} />,
    NotChecked: <CircleIcon size={size} color={palette.secondary} />,
  };

  return iconMap[status];
};

export default PoiStatusIcon;